import {
  Cup,
  FootballBall,
  BasketballBall,
  VolleyballBall,
  TennisBall,
} from '@/static';

export const getIconBySportId = (sportId: string) =>
  ({
    all: Cup,
    'sr:sport:1': FootballBall,
    'sr:sport:2': BasketballBall,
    'sr:sport:23': VolleyballBall,
    'sr:sport:5': TennisBall,
  })[sportId] || Cup;
